<template>
<div
    style="display:flex; flex-direction:column; width:100%; height:100%"
    v-if="display && showComponent"
    :key="componentRefresh"
>
    <div style="display:flex;">
        <slot name="title"></slot>
        
        <a href="" class="btn btn-link"  @click.prevent="openUploadModal" v-if="uploadOptions"><i class="fa fa-upload" aria-hidden="true"></i> Upload Files </a>
        
        <div style="margin-left:auto" v-if="showChangeViewTypeButton">
            <a href="" class="btn btn-light btn-sm" @click.prevent="viewType='grid'" v-show="viewType=='row'"> <i class="fa fa-th" aria-hidden="true"></i> </a>
            <a href="" class="btn btn-light btn-sm"  @click.prevent="viewType='row'" v-show="viewType=='grid'"><i class="fa fa-bars" aria-hidden="true"></i></a>
        </div>
    </div>

    <template v-if="isLoading">
        <div style="display:flex;justify-content:center;align-items:center;margin: 5px;" :style="{'height':height, 'width': width}" >
            <span style="font-size: 40px;color: #777777;"><i class="fas fa-spinner fa-pulse" aria-hidden="true"></i></span>
        </div>
    </template>
    <template v-else>
        <template v-if="fileList.length == 0">
            <div style="display:flex;justify-content:center;align-items:center;margin: 5px;" :style="{'height':height, 'width': width}">
                <span style="font-size: 20px;color: #777777;">Files not found...</span>
            </div>
        </template>
        <template v-else>
            <template v-if="viewType=='grid'">
                <div class="file-mosaic" :style="{'max-height':height, 'width': width}" v-if="showDefaultGrid">
                    <div class="file-mosaic-item" v-for="(file, idx) in fileList">
                        <div class="options" v-if="showActionButtons">
                            <a href="" style="color: green;" class="button" @click.prevent="set(file)" v-if="showSetButton"><i class="fa fa-check" aria-hidden="true"></i> </a>
                            <!-- <a href="" style="color: blue;" class="button" @click.prevent="edit(file)" v-if="showEditButton"><i class="fa fa-edit" aria-hidden="true"></i> </a> -->
                            <!-- <a href="" style="color: red;" class="button" @click.prevent="remove(file)" v-if="showDeleteButton"><i class="fa fa-trash" aria-hidden="true"></i></a> -->
                        </div>
                        <img :src="file._src" @click="click(file, idx)"/>
                    </div>
                </div>
                <slot name="grid" :files="fileList" v-else></slot>
            </template>
            <template v-else>
                <div class="file-row" :style="{'max-height':height, 'width': width}" v-if="showDefaultRow">
                    <div class="file-row-item" v-for="(file, idx) in fileList">
                        <div style="width:60px;height:60px;" class="file-mosaic-item" >
                            <img :src="file._src" @click="click(file, idx)"/>
                        </div>
                        <div style="display:flex;flex-direction: column;">
                            <a href="" @click.prevent="click(file, idx)">{{ file.file_name }} </a>
                            <small class="text-muted">{{file.create_datetime}}</small>
                        </div>
                        <div class="options" v-if="showActionButtons">
                            <a href="" style="color: green;" class="button" @click.prevent="set(file)" v-if="showSetButton"><i class="fa fa-check" aria-hidden="true"></i> </a>
                            <!--<a href="" style="color: blue;" class="button" @click.prevent="edit(file)" v-if="showEditButton"><i class="fa fa-edit" aria-hidden="true"></i> </a> -->
                            <!--<a href="" style="color: red;" class="button" @click.prevent="remove(file)" v-if="showDeleteButton"><i class="fa fa-trash" aria-hidden="true"></i></a> -->
                        </div>
                    </div>
                </div>
                <slot name="row" :files="fileList" v-else></slot>
            </template>
        </template>
    </template>

    <ks-file-viewer-modal
        v-if="openFileViewerModalOnClick && fileList.length > 0"
        :ref="`fileListFileViewerModal${_uid}`"
        :files="fileList"
        :modalTitle="fileViewerModalTitle"
    >
    </ks-file-viewer-modal>


    <ks-modal 
        v-if="uploadOptions"
        :ref="`fileListFileUploadModal${_uid}`" 
        position="centered" 
        modalWidth="50" 
        :dataBackdrop="false"
        :dataKeyboard="false"
    >
        <ks-modal-body>
            <ks-upload-files
                :uploadOptions="uploadOptions"
                @onUpload="uploadedFiles"
            >
            </ks-upload-files>
        </ks-modal-body>
    </ks-modal>
</div>
</template>
            
<script>
import checkPermissions from '../../mixins/checkPermissions';
import getSRCThumbnail from '../../mixins/getSRCThumbnail';
import _ from 'lodash'
export default {
    name: 'file-list',
    mixins: [checkPermissions, getSRCThumbnail],
    props:{
        defaultViewType:{
            type: String,
            default: "grid"
        },
        defaultFilters:{
            type: Object,
            default: null
        },
        files:{
            type: Array,
            default: () => []
        },
        display: {
            type: Boolean,
            default: true
        },
        changeViewType:{
            type: Boolean,
            default: true
        },
        height: {
            type: String,
            default: '27dvh'
        },
        width:{
            type: String,
            default: '100%'
        },
        showChangeViewTypeButton:{
            type: Boolean,
            default: true
        },
        showActionButtons:{
            type: Boolean,
            default: true
        },
        showDefaultGrid:{
            type: Boolean,
            default: true
        },
        showDefaultRow:{
            type: Boolean,
            default: true
        },
        showSetButton:{
            type:Boolean,
            default: true
        },
        showEditButton:{
            type:Boolean,
            default: true
        },
        showDeleteButton:{
            type:Boolean,
            default: true
        },
        openFileViewerModalOnClick:{
            type: Boolean,
            default: false
        },
        fileViewerModalTitle:{
            type:String,
            default:null
        },
        uploadOptions:{
            type: Object,
            default: null
        }
    },
    computed:{
        app() {
            return window.app;
        }
    },
    watch:{
        files:{
            handler:function(val, oldval){
                if(!_.isEqual(val, oldval))this.loadFileList();
            },
            deep:true
        },
        defaultFilters:{
            handler:function(val, oldval){
                if(!_.isEqual(val, oldval)) this.loadFileList();
            }
        }
    },
    methods:{
        async loadFileList(){
            if(this.defaultFilters){
                this.isLoading = true;
                try{
                    const res = await app.data.list("file.file", this.defaultFilters);
                    const files = res.list;                    
                    this.fileList = files.map((file) => { return {...file, '_src':`${this.getSRCThumbnail(file, true)}`, 'src': `${app.apiURL}/file/files/${file.file_code_id||file.code_id}?token=${window.app.auth.urlToken}`} });
                    this.isLoading = false;
                }catch(err){
                    console.log(err);
                    this.isLoading = false;
                    return;
                }
            }else if(this.files){
                this.fileList = this.files.map(file => {
                    if(typeof file == 'object' )return file;
                    else return {'_src': file};
                });
            }
            this.$emit('onLoadList', this);
        },
        set(file){
            this.$emit('onSet', {ref:this, file:file});
        },
        edit(file){
            this.$emit('onEdit', {ref:this, file:file});
        },
        async remove(file){
            try{
                await app.data.update("file.file", {"campaign_id": file.campaign_id, "file_id": file.id, "delete_file":1, "write_nulls": false });
                this.loadFileList();
            }catch(err){
                console.error(err);
            }
            this.$emit('onRemove', {ref:this, file:file});
        },
        click(file, idx){
            if(this.openFileViewerModalOnClick){ this.$refs[`fileListFileViewerModal${this._uid}`].open(idx); }
            this.$emit('onClick', {ref:this, file:file, index:idx});
        },
        uploadedFiles(){
            this.loadFileList();
        },
        openUploadModal(){
            this.$refs[`fileListFileUploadModal${this._uid}`].show();
        }
    },
    mounted(){
        this.loadFileList();
    },
    data(){
        return{
            fileList: [],
            viewType: this.defaultViewType,
            isLoading: false
        }
    }
}
</script>